import { Link, useParams } from "react-router-dom";
import SpecialityForm from "./SpecialityForm";

const CreateSpeciality = () => {
    const { country } = useParams();
    return (
        <div className="row justify-content-center">
            <div className="col-md-10">
                <div className="custom-shadow p-5">
                    <Link
                        to={`/abbvie-pro/group-specialties/${country}`}
                        className="btn btn-outline-primary mb-5"
                    >
                        Back
                    </Link>
                    <h3 className="mb-5">Create Specialty</h3>

                    <SpecialityForm />
                </div>
            </div>
        </div>
    );
};

export default CreateSpeciality;
